// File: src/pages/master/EditSuperAdmin.jsx
import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Label,
  Row,
  CardBody,
  Spinner,
  Alert,
} from "reactstrap";
import {
  SubscriptinPlanList,
  Update_individual_plan,
  View_User_By_Id,
  country_state_City_List,
} from "../../import/ApiEndPoint/Api";
import {
  _Get,
  _GetList,
  _Put,
  ViewCompanyDetails,
  EditUserProfile,
  Create_CompanyDetails,
} from "../../import/ApiEndPoint/ApiCalling";
import swal from "sweetalert";
import { useNavigate, useParams } from "react-router-dom";
import { baseURL } from "../../import/ApiEndPoint/TestApi";

/* page-scoped CSS (same vibe as View page) */
const injectOnce = () => {
  if (document.getElementById("edit-sa-inline-css")) return;
  const s = document.createElement("style");
  s.id = "edit-sa-inline-css";
  s.textContent = `
    .esa-toolbar{ padding:8px; background:#f4f7f6; border-radius:14px; border:1px solid #e5e7eb; }
    .esa-title{ font-weight:800; text-transform:uppercase; font-size:18px; }
    .esa-card{ border-radius:14px; border:1px solid #e5e7eb; }
    .esa-section{ margin: 8px; }
    .esa-scroll{ max-height: 420px; overflow: auto; border:1px solid #e5e7eb; border-radius: 8px; padding: 10px; background:#fff; }
  `;
  document.head.appendChild(s);
};

export default function EditSuperAdmin() {
  const [Data, setData] = useState({});
  const [SubsCriptionList, setSubsCriptionList] = useState([]);
  const [companyDetails, setCompanyDetails] = useState({
    name: "",
    email: "",
    gstNo: "",
    reDate: "",
    mobileNo: "",
    address: "",
    signature: "",
    file: "",
    bankDetails: [
      {
        bankName: "",
        accountNumber: "",
        branchName: "",
        bankIFSC: "",
        bankAddress: "",
        bankMicr: "",
        upiId: "",
        gpay_PhonepayNumber: "",
      },
    ],
  });
  const [Country_State_city, setCountry_State_city] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const navigate = useNavigate();
  const Params = useParams();

  useEffect(() => injectOnce(), []);

  // Resolve database robustly
  const db = useMemo(() => {
    try {
      const u = JSON.parse(localStorage.getItem("userData") || "{}");
      return (
        Data?.database ||
        u?.database ||
        u?.db ||
        u?.DBName ||
        u?.dbname ||
        u?.Database ||
        ""
      );
    } catch {
      return Data?.database || "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Data?.database]);

  // ===== Load lookups =====
  useEffect(() => {
    (async () => {
      try {
        const res = await _GetList(country_state_City_List);
        setCountry_State_city(Array.isArray(res) ? res : []);
      } catch (e) {
        setCountry_State_city([]);
      }
    })();
  }, []);

  // ===== Load user + plans =====
  useEffect(() => {
    (async () => {
      if (!Params?.id) return;
      setLoading(true);
      setErrMsg("");

      try {
        let res;
        // Try /:id/:db first
        if (db) {
          try {
            res = await _Get(
              View_User_By_Id,
              `${Params.id}/${encodeURIComponent(db)}`
            );
          } catch (e1) {
            // fallback to /:id
          }
        }
        if (!res) {
          res = await _Get(View_User_By_Id, Params.id);
        }

        const value = res?.User;
        if (!value) {
          setErrMsg("No user found for this id.");
          setData({});
        } else {
          const a = value?.subscriptionPlan || {};
          const merged = {
            ...value,
            annualMaintenanceCost: a?.annualMaintenanceCost,
            createdAt: a?.createdAt,
            days: a?.days,
            noOfUser: a?.noOfUser,
            planName: a?.planName,
            subscriptionPlan: a?._id,
            originalSubscriptionPlan: a?._id, // keep original to compare later
            subscriptionCost: a?.subscriptionCost,
            subscriptionType: a?.subscriptionType,
          };
          setData(merged);
        }

        try {
          const plans = await _GetList(SubscriptinPlanList, db || undefined);
          const list = Array.isArray(plans?.Subscription)
            ? plans.Subscription
            : [];
          setSubsCriptionList(list);
        } catch {
          setSubsCriptionList([]);
        }
      } catch (err) {
        setErrMsg(
          err?.response?.data?.message ||
            err?.message ||
            "Failed to load super admin"
        );
      } finally {
        setLoading(false);
      }
    })();
  }, [Params?.id, db]);

  // ===== Load company details (after Data is ready) =====
  useEffect(() => {
    (async () => {
      try {
        if (!Params?.id) return;
        const resp = await ViewCompanyDetails(Params?.id, db || undefined);
        const c = resp?.CompanyDetail || {};
        setCompanyDetails((prev) => ({
          ...prev,
          ...c,
          bankDetails:
            (Array.isArray(c?.bankDetails) && c.bankDetails.length
              ? c.bankDetails
              : prev.bankDetails) || prev.bankDetails,
        }));
      } catch {
        // keep defaults
      }
    })();
  }, [Params?.id, db]);

  // ===== Handlers =====
  const handleInputChange = (e) => {
    const { name, value, files, type } = e.target;
    if (files && files.length > 0) {
      setData((p) => ({ ...p, [name]: files[0] }));
      return;
    }
    // special: pincode → auto-fill city/state/country
    if (name === "pincode") {
      const SelectedCity = Country_State_city.find(
        (ele) => ele.Pincode === value
      );
      if (SelectedCity) {
        setData((p) => ({
          ...p,
          pincode: value,
          City: SelectedCity.District,
          State: SelectedCity.StateName,
          Country: "India",
        }));
      } else {
        setData((p) => ({
          ...p,
          pincode: value,
          City: "",
          State: "",
          Country: "",
        }));
      }
      return;
    }
    setData((p) => ({ ...p, [name]: type === "number" ? value : value }));
  };

  const handleCompany_BankDetailChange = (e) => {
    const { name, files, value } = e.target;
    if (files && files.length > 0) {
      setCompanyDetails((p) => ({ ...p, [name]: files[0] }));
    } else {
      setCompanyDetails((p) => ({ ...p, [name]: value }));
    }
  };

  const handleBankDetailChange = (e, index) => {
    const { name, value } = e.target;
    setCompanyDetails((p) => {
      const next = Array.isArray(p.bankDetails) ? [...p.bankDetails] : [];
      next[index] = { ...(next[index] || {}), [name]: value };
      return { ...p, bankDetails: next };
    });
  };

  const addMoreBankDetails = () => {
    setCompanyDetails((p) => ({
      ...p,
      bankDetails: [
        ...(Array.isArray(p.bankDetails) ? p.bankDetails : []),
        {
          bankName: "",
          accountNumber: "",
          branchName: "",
          bankIFSC: "",
          bankAddress: "",
          bankMicr: "",
          upiId: "",
          gpay_PhonepayNumber: "",
        },
      ],
    }));
  };

  // ==== Single Update button → update personal + company/bank + plan(if changed)
  const handleUpdateAll = async () => {
    setSaving(true);

    const results = { personal: null, company: null, plan: null };
    let hadError = false;

    // 1) Personal details (allowed keys only)
    try {
      const fd = new FormData();
      const allowedKeys = [
        "firstName",
        "email",
        "Country",
        "State",
        "City",
        "Aadhar_No",
        "Pan_No",
        "pincode",
        "mobileNumber",
        "geotagging",
        "password",
        "cnfmPassword",
        "address1",
      ];
      allowedKeys.forEach((k) => {
        if (Object.prototype.hasOwnProperty.call(Data, k)) {
          const v = Data[k];
          if (v !== undefined && v !== null) fd.append(k, v);
        }
      });
      await EditUserProfile(Params.id, fd);
      results.personal = "ok";
    } catch (e) {
      hadError = true;
      results.personal =
        e?.response?.data?.message || e?.message || "Personal update failed";
    }

    // 2) Company + Bank details
    try {
      const formData = new FormData();
      const allowedCompanyKeys = [
        "created_by",
        "email",
        "name",
        "mobileNo",
        "file", // company logo (File)
        "gstNo",
        "Prefix",
        "Suffix",
        "address",
        "signature", // signature (File)
        "reDate",
      ];
      Object.keys(companyDetails || {}).forEach((k) => {
        const v = companyDetails[k];
        if (allowedCompanyKeys.includes(k) && v !== undefined && v !== null) {
          formData.append(k, v);
        }
      });
      // ensure created_by is set to this user id
      if (!("created_by" in companyDetails) && Params?.id) {
        formData.append("created_by", Params.id);
      }
      // bank details as JSON
      formData.append(
        "bankDetails",
        JSON.stringify(
          Array.isArray(companyDetails?.bankDetails)
            ? companyDetails.bankDetails
            : []
        )
      );

      await Create_CompanyDetails(formData);
      results.company = "ok";
    } catch (e) {
      hadError = true;
      results.company =
        e?.response?.data?.message || e?.message || "Company update failed";
    }

    // 3) Plan (only if changed)
    try {
      const newPlan = Data?.subscriptionPlan || "";
      const oldPlan = Data?.originalSubscriptionPlan || "";
      if (newPlan && newPlan !== oldPlan) {
        // sanitize trailing slash on path to avoid //id
        const safePath = String(Update_individual_plan || "").replace(
          /\/+$/,
          ""
        );
        await _Put(safePath, Params.id, { subscriptionPlan: newPlan });
        results.plan = "ok";
      } else {
        results.plan = "skipped";
      }
    } catch (e) {
      hadError = true;
      results.plan =
        e?.response?.data?.message || e?.message || "Plan update failed";
    }

    setSaving(false);

    if (!hadError) {
      swal("Success", "Updated successfully", "success");
      // optional: reload latest data
      navigate(-1);
    } else {
      let msg = "Some updates failed:\n";
      if (results.personal !== "ok") msg += `• Personal: ${results.personal}\n`;
      if (results.company !== "ok") msg += `• Company: ${results.company}\n`;
      if (results.plan !== "ok" && results.plan !== "skipped")
        msg += `• Plan: ${results.plan}\n`;
      swal("Partial Success", msg, "warning");
    }
  };

  // ===== Loading =====
  if (loading) {
    return (
      <>
        <Card className="esa-toolbar mb-1">
          <div className="d-flex justify-content-between align-items-center">
            <div className="esa-title">Edit Super Admin</div>
            <div className="d-flex" style={{ gap: 8 }}>
              <Button color="secondary" onClick={() => navigate(-1)}>
                Back
              </Button>
            </div>
          </div>
        </Card>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "6rem",
          }}
        >
          <Spinner style={{ height: "3rem", width: "3rem" }} color="primary">
            Loading...
          </Spinner>
        </div>
      </>
    );
  }

  return (
    <>
      {/* ===== Title / Actions card ===== */}
      <Card className="esa-toolbar mb-1">
        <div className="d-flex justify-content-between align-items-center">
          <div className="esa-title">Edit Super Admin</div>
          <div className="d-flex" style={{ gap: 8 }}>
            <Button color="primary" onClick={handleUpdateAll} disabled={saving}>
              {saving ? "Updating..." : "Update"}
            </Button>
            <Button
              color="secondary"
              onClick={() => navigate(-1)}
              disabled={saving}
            >
              Back
            </Button>
          </div>
        </div>
      </Card>

      {errMsg ? (
        <Alert color="danger" className="mb-2" style={{ borderRadius: 12 }}>
          {errMsg}
        </Alert>
      ) : null}

      {/* ===== Main content card ===== */}
      <Card className="esa-card">
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-around",
          }}
        >
          {/* ===== Personal Details ===== */}
          <CardBody className="userRegiBody col-12 col-md-6 esa-section">
            <h5>Personal Details</h5>
            <Row>
              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>FirstName*</Label>
                <Input
                  type="text"
                  name="firstName"
                  placeholder="Enter FirstName"
                  value={Data.firstName || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Email *</Label>
                <Input
                  type="email"
                  name="email"
                  placeholder="Enter Email"
                  value={Data.email || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Mobile Number *</Label>
                <Input
                  type="number"
                  name="mobileNumber"
                  placeholder="Mobile Number"
                  value={Data.mobileNumber || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Pin Code *</Label>
                <Input
                  type="text"
                  name="pincode"
                  placeholder="Pin Code"
                  value={Data.pincode || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>City *</Label>
                <Input
                  type="text"
                  name="City"
                  placeholder="City"
                  value={Data.City || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>State *</Label>
                <Input
                  type="text"
                  name="State"
                  placeholder="State"
                  value={Data.State || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Country *</Label>
                <Input
                  type="text"
                  name="Country"
                  placeholder="Country"
                  value={Data.Country || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Aadhar No.*</Label>
                <Input
                  type="number"
                  name="Aadhar_No"
                  placeholder="Aadhar No"
                  value={Data.Aadhar_No || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Pan No.*</Label>
                <Input
                  type="text"
                  name="Pan_No"
                  placeholder="Pan No"
                  value={Data.Pan_No || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Password *</Label>
                <Input
                  type="text"
                  name="password"
                  placeholder="Password"
                  value={Data.password || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Geotagging *</Label>
                <Input
                  type="text"
                  name="geotagging"
                  placeholder="geotagging"
                  value={Data.geotagging || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="12" md="12">
                <Label>Personal Address One*</Label>
                <Input
                  type="textarea"
                  name="address1"
                  placeholder="Address One"
                  value={Data.address1 || ""}
                  onChange={handleInputChange}
                />
              </Col>
            </Row>
          </CardBody>

          {/* ===== Company Details ===== */}
          <CardBody className="userRegiBody col-12 col-md-5 esa-section">
            <h5>Company Details</h5>
            <Row>
              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Company Name*</Label>
                <Input
                  type="text"
                  name="name"
                  placeholder="Enter CompanyName"
                  value={companyDetails.name || ""}
                  onChange={handleCompany_BankDetailChange}
                />
              </Col>

              <Col
                className="mb-1 mt-1"
                lg="4"
                md="4"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Label>
                  Signature{" "}
                  {companyDetails?.signature &&
                  typeof companyDetails.signature === "string" ? (
                    <img
                      src={`${baseURL}/Images/${companyDetails.signature}`}
                      alt="Signature"
                      style={{
                        width: "100px",
                        height: "50px",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <span>No signature available</span>
                  )}
                </Label>
                <Input
                  type="file"
                  name="signature"
                  onChange={handleCompany_BankDetailChange}
                />
              </Col>

              <Col
                className="mb-1 mt-1"
                lg="4"
                md="4"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Label>
                  Company Logo{" "}
                  {companyDetails?.logo &&
                  typeof companyDetails.logo === "string" ? (
                    <img
                      src={`${baseURL}/Images/${companyDetails.logo}`}
                      alt="Company Logo"
                      style={{
                        width: "100px",
                        height: "50px",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <span>No logo available</span>
                  )}
                </Label>
                <Input
                  type="file"
                  name="file"
                  onChange={handleCompany_BankDetailChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Email *</Label>
                <Input
                  type="email"
                  name="email"
                  placeholder="Enter Email"
                  value={companyDetails.email || ""}
                  onChange={handleCompany_BankDetailChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Gst Number *</Label>
                <Input
                  type="number"
                  name="gstNo"
                  placeholder="Enter Gst Number"
                  value={companyDetails.gstNo || ""}
                  onChange={handleCompany_BankDetailChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Registration Date *</Label>
                <Input
                  type="date"
                  name="reDate"
                  placeholder="Enter Date"
                  value={companyDetails.reDate || ""}
                  onChange={handleCompany_BankDetailChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Company Number *</Label>
                <Input
                  type="number"
                  name="mobileNo"
                  placeholder="Enter Company Number"
                  value={companyDetails.mobileNo || ""}
                  onChange={handleCompany_BankDetailChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="8" md="8">
                <Label>Company Address *</Label>
                <Input
                  type="textarea"
                  name="address"
                  placeholder="Address"
                  value={companyDetails.address || ""}
                  onChange={handleCompany_BankDetailChange}
                />
              </Col>
            </Row>
          </CardBody>

          {/* ===== Plan Details ===== */}
          <CardBody className="userRegiBody col-12 col-md-6 mt-2 esa-section">
            <h5>Plan Details</h5>
            <Row>
              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Plan Status *</Label>
                <Input
                  type="select"
                  name="planStatus"
                  value={Data.planStatus || ""}
                  onChange={handleInputChange}
                >
                  <option value="Paid">Paid</option>
                  <option value="unPaid">unPaid</option>
                  <option value="Expiry">Expiry</option>
                </Input>
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Change Plan</Label>
                <Input
                  type="select"
                  value={Data.subscriptionPlan || ""}
                  onChange={(e) =>
                    setData((p) => ({ ...p, subscriptionPlan: e.target.value }))
                  }
                >
                  <option value="">----select Plan----</option>
                  {SubsCriptionList?.length > 0 &&
                    SubsCriptionList.map((ele) => (
                      <option key={ele?._id} value={ele?._id}>
                        {ele?.planName} (Price - {ele?.subscriptionCost})(
                        {ele?.subscriptionType === 1 ? "Yearly" : "One Time"})
                      </option>
                    ))}
                </Input>
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Plan Name *</Label>
                <Input
                  type="text"
                  name="planName"
                  placeholder="Plan Name"
                  value={Data.planName || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Plan Price *</Label>
                <Input
                  type="text"
                  name="subscriptionCost"
                  placeholder="Plan Price"
                  value={Data.subscriptionCost || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Plan StartDate *</Label>
                <Input
                  type="text"
                  name="planStart"
                  placeholder="Plan Start Date"
                  value={Data.planStart || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Plan EndDate*</Label>
                <Input
                  type="text"
                  name="planEnd"
                  placeholder="Plan End Date"
                  value={Data.planEnd || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Total User Allowed*</Label>
                <Input
                  type="number"
                  name="noOfUser"
                  placeholder="No Of User Allowed"
                  value={Data.noOfUser || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="4" md="4">
                <Label>Registered User *</Label>
                <Input
                  type="text"
                  name="PlanPrice"
                  placeholder="Registered User"
                  value={Data.PlanPrice || ""}
                  onChange={handleInputChange}
                />
              </Col>

              <Col className="mb-1 mt-1" lg="2" md="2">
                <Label>Total Days*</Label>
                <Input
                  type="text"
                  name="days"
                  placeholder="Total Days"
                  value={Data.days || ""}
                  onChange={handleInputChange}
                />
              </Col>
            </Row>
          </CardBody>

          {/* ===== Bank Details (multiple) ===== */}
          <CardBody className="userRegiBody col-12 col-md-5 mt-2 esa-section">
            <h5>Bank Details</h5>
            <div className="esa-scroll">
              {Array.isArray(companyDetails.bankDetails) &&
                companyDetails.bankDetails.map((bank, index) => (
                  <Row key={index} className="border rounded p-2 mb-2">
                    <Col className="mb-1 mt-1" lg="4" md="4">
                      <Label>Bank Name *</Label>
                      <Input
                        type="text"
                        name="bankName"
                        placeholder="Bank Name"
                        value={bank.bankName || ""}
                        onChange={(e) => handleBankDetailChange(e, index)}
                      />
                    </Col>

                    <Col className="mb-1 mt-1" lg="4" md="4">
                      <Label>Account Number *</Label>
                      <Input
                        type="text"
                        name="accountNumber"
                        placeholder="Account Number"
                        value={bank.accountNumber || ""}
                        onChange={(e) => handleBankDetailChange(e, index)}
                      />
                    </Col>

                    <Col className="mb-1 mt-1" lg="4" md="4">
                      <Label>Branch Name *</Label>
                      <Input
                        type="text"
                        name="branchName"
                        placeholder="Branch Name"
                        value={bank.branchName || ""}
                        onChange={(e) => handleBankDetailChange(e, index)}
                      />
                    </Col>

                    <Col className="mb-1 mt-1" lg="4" md="4">
                      <Label>IFSC Code *</Label>
                      <Input
                        type="text"
                        name="bankIFSC"
                        placeholder="IFSC Code"
                        value={bank.bankIFSC || ""}
                        onChange={(e) => handleBankDetailChange(e, index)}
                      />
                    </Col>

                    <Col className="mb-1 mt-1" lg="4" md="4">
                      <Label>Bank Address *</Label>
                      <Input
                        type="text"
                        name="bankAddress"
                        placeholder="Bank Address"
                        value={bank.bankAddress || ""}
                        onChange={(e) => handleBankDetailChange(e, index)}
                      />
                    </Col>

                    <Col className="mb-1 mt-1" lg="4" md="4">
                      <Label>MICR Code *</Label>
                      <Input
                        type="text"
                        name="bankMicr"
                        placeholder="MICR Code"
                        value={bank.bankMicr || ""}
                        onChange={(e) => handleBankDetailChange(e, index)}
                      />
                    </Col>

                    <Col className="mb-1 mt-1" lg="4" md="4">
                      <Label>UPI Id *</Label>
                      <Input
                        type="text"
                        name="upiId"
                        placeholder="UPI Id"
                        value={bank.upiId || ""}
                        onChange={(e) => handleBankDetailChange(e, index)}
                      />
                    </Col>

                    <Col className="mb-1 mt-1" lg="4" md="4">
                      <Label>GPay/PhonePe Number *</Label>
                      <Input
                        type="text"
                        name="gpay_PhonepayNumber"
                        placeholder="GPay/PhonePe Number"
                        value={bank.gpay_PhonepayNumber || ""}
                        onChange={(e) => handleBankDetailChange(e, index)}
                      />
                    </Col>
                  </Row>
                ))}
            </div>
            <div className="d-flex justify-content-end mt-2">
              <Button
                type="button"
                color="success"
                onClick={addMoreBankDetails}
              >
                + Add Another Bank
              </Button>
            </div>
          </CardBody>
        </div>
      </Card>
    </>
  );
}
